module.exports = __webpack_public_path__ + "img/search-Icon.76163b92.svg";